module.exports = __webpack_public_path__ + "static/media/display-4@768.4a27061c.png";